import { Notification, NotificationType } from "./types";
import React from "react";
import { SingleSessionNotification } from "./SingleSessionNotification";
import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { MultipleSessionsNotification } from "./MultipleSessionsNotification";
import { GapBetweenSessionsNotification } from "./GapBetweenSessionsNotification";

export interface NotificationContentProps {
    uniqueId: string;
    notification: Notification;
}

/**
 * Channel Tv - main notification content component which renders notification content by notification type
 */
export const NotificationContent = ({ notification, uniqueId }: NotificationContentProps) => {
    let notificationContent: React.ReactNode;

    switch (notification.type) {
        case NotificationType.single:
            notificationContent = <SingleSessionNotification id={uniqueId} notification={notification} />;
            break;
        case NotificationType.many:
            notificationContent = <MultipleSessionsNotification id={uniqueId} notification={notification} />;
            break;
        case NotificationType.gap:
            notificationContent = <GapBetweenSessionsNotification id={uniqueId} notification={notification} />;
            break;
        default:
            notificationContent = null;
    }

    return <StyledContentWrapper>{notificationContent}</StyledContentWrapper>;
};

const StyledContentWrapper = styled(Box)(({ theme }) => ({
    color: theme.kaltura.palette.translucent.contrastText,
}));

export const StyledNotificationTitle = styled(Box)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
}));

export const StyledNotificationTitlePadded = styled(StyledNotificationTitle)(({ theme }) => ({
    paddingBottom: theme.spacing(2),
}));

export const StyledNotificationButtons = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(2),
    gap: theme.spacing(1),
}));

export const StyledNotificationWithThumbnailContainer = styled(Box)({
    display: "flex",
    alignItems: "flex-start",
});

export const Thumbnail = styled("img")(({ theme }) => ({
    width: 100,
    height: 56,
    borderRadius: theme.kaltura.shape.roundness1,
    marginRight: theme.spacing(1),
}));
